import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { CustoMaterialServico } from 'src/app/admihair/api/dto/custo-material-servico';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { CustoMaterialServicoService } from 'src/app/admihair/service/custo-material-servico.service';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-item-servico-detalhar',
  templateUrl: './item-servico-detalhar.component.html',
  styleUrls: ['./item-servico-detalhar.component.scss']
})
export class ItemServicoDetalharComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('f') form?: NgForm;
  loadingServico: boolean = false;
  loadingSpinnerDialog: boolean = false;
  id?: number;
  itemServico?: ItemServico;

  listaItensCustoAdicionados: CustoMaterialServico[] = [];
  valorTotalCustoMaterial: number = 0;


  exibirDialogValorSugerido: boolean = false;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  valorVenda: number = 0;
  valorLucroDesejado: number = 0;
  valorLucroObtido: number = 0;
  valorSugerido: number = 0;
  novoValorServico: number = 0;
  valorLucroObtidoAtual: number = 0;

  constructor(private custoMaterialServicoService: CustoMaterialServicoService,
    private custoService: CustoService,
    private activatedRouter: ActivatedRoute,
    private itemServicoService: ItemServicoService,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService)
  }


  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_SERVICO');
    this.carregarIdItemServico();
    if (this.permissaoDetalhar) {
      this.carregarItemServicoPorId();
    }
  }

  carregarItemServicoPorId() {
    this.loadingServico = true;
    this.itemServicoService.buscarItemServicoPorId(this.id).subscribe({
      next: (data: ItemServico) => {
        this.itemServico = data;
        this.carregarListaCusto()
      },
      error: (err: any) => {
        this.loadingServico = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  carregarListaCusto() {
    this.custoMaterialServicoService.listarPorItemServicoId(this.itemServico?.id).subscribe({
      next: (data: CustoMaterialServico[]) => {
        this.listaItensCustoAdicionados = data;
        this.calcularValorTotalCusto();
        this.loadingServico = false;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  calcularValorTotalCusto() {
    for (let item of this.listaItensCustoAdicionados) {
      if (item.itemProduto?.valorCompra && item.quantidadeUnidadeMedida && item.quantidade) {
        this.valorTotalCustoMaterial = this.valorTotalCustoMaterial + (item.itemProduto.valorCompra / item.quantidadeUnidadeMedida) * item.quantidade;
      }
    }
  }

  carregarIdItemServico() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }

  }

  abrirDialogValorSugerido() {
    this.loadingSpinnerDialog = true;
    this.novoValorServico = 0;
    this.valorLucroDesejado = 0;
    this.valorLucroObtido = 0;
    this.valorSugerido = 0;
    this.exibirDialogValorSugerido = true;
    this.obterCustos();
  }

  obterCustos() {
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.calcularLucroObtidoAtual();
        this.loadingSpinnerDialog = false;
      },
      error: (err: any) => {
        this.loadingSpinnerDialog = false;
        this.exibirDialogValorSugerido = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  calcularLucroObtidoAtual() {
    if (this.itemServico
      && this.itemServico.valorVenda
      && this.itemServico.valorVenda > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const valorCustosTotais = (somaPercentuais / 100) * this.itemServico.valorVenda;
      this.valorLucroObtidoAtual = Number((this.itemServico.valorVenda - valorCustosTotais).toFixed(2));
    } else {
      this.valorLucroObtidoAtual = 0;
    }
  }

  calcularLucroDesejado(event: any) {
    this.valorLucroDesejado = event.value ?? 0;
    if (this.valorLucroDesejado > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const sugestao = ((this.valorLucroDesejado * somaPercentuais) / ((somaPercentuais - 100) * -1)) + this.valorLucroDesejado;
      this.valorSugerido = sugestao;
    } else {
      this.valorSugerido = 0;
    }
  }

  calcularLucroObtido(valor?: number) {
    this.novoValorServico = valor ?? 0;
    if (this.novoValorServico > 0) {
      const somaPercentuais = this.custoMedio.custoFixo + (this.itemServico?.custoMaterial ?? 0)
        + (this.itemServico?.comissaoVenda ?? 0) + this.custoMedio.imposto;
      const valorCustosTotais = (somaPercentuais / 100) * this.novoValorServico;
      if (this.novoValorServico) {
        this.valorLucroObtido = Number((this.novoValorServico - valorCustosTotais).toFixed(2));
      }
    } else {
      this.valorLucroObtido = 0;
    }
  }

}
